import * as React from 'react';
import * as PropTypes from 'prop-types';
import Joyride, { ACTIONS, EVENTS, STATUS, LIFECYCLE } from 'react-joyride';
import { debounce, filter, get } from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'redux-little-router';
import { setShowTourStatus } from '../../redux/bannerList/actions';
import { isVisible } from './helpers';
import STEPS, { STEP_GROUPS } from './steps';
import { joyrideLocale, joyrideStyles } from './configs';
import { routeMap } from '../../../../router';
import TourTooltip from './components/TourTooltip';

class Tour extends React.Component {
  static propTypes = {
    showTour: PropTypes.bool.isRequired,
    tourFinishedAction: PropTypes.func,
    group: PropTypes.symbol,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    goToHome: PropTypes.func.isRequired,
    hideTour: PropTypes.func.isRequired,
  };

  static defaultProps = {
    group: STEP_GROUPS.MAIN,
  };

  state = {
    steps: [],
    group: this.props.group,
    run: false,
    joyrideLocale: {},
    showProgress: true,
  };

  joyrideStyles = joyrideStyles;

  handleWindowResize = debounce(() => {
    this.setState({
      steps: this.getVisibleSteps(),
    });
  }, 100);

  componentDidMount() {
    this.startTour();
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  async startTour() {
    const { showTour } = this.props;

    this.setState({
      run: showTour,
      steps: this.getVisibleSteps(),
      joyrideLocale: joyrideLocale,
    });
  }

  getVisibleSteps(stepsGroup = this.state.group) {
    const stepsList = STEPS[stepsGroup] || [];
    return filter(stepsList, (step) => {
      /**для мобилки хак*/
      if (window.matchMedia('(max-width: 1140px)').matches) {
        step.target =
          step.target === '.menu.menu__main > [data-tour="mainmenu__taxes"]'
            ? '.menu.menu__pages > [data-tour="mainmenu__taxes"]'
            : step.target;
      }
      const element = document.querySelector(step.target);
      if (!element) {
        return false;
      }
      return isVisible(element);
    });
  }

  setSteps = (stepsGroup) => {
    /**пока понял что нужно остановить прежде чем стартовать заного*/
    this.setState({ run: false });
    setTimeout(() => {
      this.setState({
        steps: this.getVisibleSteps(stepsGroup),
        group: stepsGroup,
        run: true,
      });
    }, 0);
  };

  goToLastSteps = () => {
    this.setSteps(STEP_GROUPS.LAST);
  };

  successTour = () => {
    const { goToHome, hideTour } = this.props;
    hideTour();
    goToHome();
  };

  scrollIntoView = (target) => {
    setTimeout(() => {
      const el = document.querySelector(target);
      el && el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 0);
  };

  handleJoyrideCallback = (data) => {
    /**По хорошему избавиться от state.group и описать всю логику здесь*/
    const { tourFinishedAction } = this.props;
    const { group, showProgress, run, steps } = this.state;
    const { index, size, status, type, action, step, lifecycle } = data;
    const isLastStep = index + 1 === size;
    const isLastStepTour = group === STEP_GROUPS.LAST && isLastStep;
    if (!run) {
      return;
    }
    if ([EVENTS.STEP_BEFORE].includes(type)) {
      isLastStep
        ? this.setState({ showProgress: false })
        : !showProgress && this.setState({ showProgress: true });
      isLastStepTour
        ? this.setState({
            joyrideLocale: { ...this.state.joyrideLocale, last: 'Готово' },
          })
        : null;
    }
    if ([EVENTS.STEP_AFTER].includes(type)) {
      this.setState({ run: false });
      const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      this.scrollIntoView(get(steps, `[${stepIndex}].target`));
      if (isLastStepTour || group === STEP_GROUPS.LAST) {
        return;
      }
      setTimeout(() => {
        this.setState({ run: true });
      }, 300);
    }
    if ([LIFECYCLE.TOOLTIP].includes(lifecycle) && index === 0) {
      this.scrollIntoView(step.target);
    }

    if ([STATUS.FINISHED].includes(status)) {
      isLastStepTour || group === STEP_GROUPS.LAST
        ? this.successTour()
        : tourFinishedAction && tourFinishedAction();
    }
    if ([STATUS.SKIPPED].includes(status)) {
      this.setState({
        joyrideLocale: { ...this.state.joyrideLocale, last: 'Понятно' },
        showProgress: false,
      });
      this.goToLastSteps();
    }
  };

  render() {
    const { steps, run, joyrideLocale, showProgress } = this.state;
    const { children } = this.props;
    return (
      <>
        <Joyride
          tooltipComponent={TourTooltip}
          steps={steps}
          run={run}
          continuous={true}
          showProgress={showProgress}
          showSkipButton={true}
          disableCloseOnEsc={true}
          disableOverlayClose={true}
          locale={joyrideLocale}
          callback={this.handleJoyrideCallback}
          styles={this.joyrideStyles}
          disableScrollParentFix={true}
          disableScrolling={true}
          scrollToFirstStep={false}
        />
        {children}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      hideTour: () => setShowTourStatus(false, true),
      goToHome: () => push({ pathname: routeMap.home }),
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(Tour);
